<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="page-inside-top">
          <div class="wrapper">
            <div
              :class="[
                'title',
                'big',
                { 'error-title': status === 'failure', success: status === 'success' },
              ]"
            >
              {{ getTitle }}
            </div>
            <div :class="['title', { 'error-desc': status === 'failure' }]">
              {{ getDescription }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "PayoutResultPage",
  props: {
    status: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
  },
  computed: {
    getTitle() {
      if (this.status === 'success') {
        return this.$t('PAYOUT SUCCESSFUL');
      } else if (this.status === 'failure') {
        return this.$t('PAYOUT FAILED');
      } else if (this.status === 'pending') {
        return this.$t('PAYOUT PENDING');
      }
      return '';
    },
    getDescription() {
      if (this.message) {
        return this.message;
      }
      if (this.status === 'success') {
        return this.$t('Your payout request has been successfully submitted. Your funds will be transferred to your bank account soon.');
      } else if (this.status === 'failure') {
        return this.$t('Your payout request could not be processed. Please try again or contact support.');
      } else if (this.status === 'pending') {
        return this.$t('Your payout request is being processed. You will receive an email notification once it is complete.');
      }
      return '';
    },
  },
};
</script>

<style scoped>
.page-inside .hero-section .wrapper > .title {
  margin-bottom: 20px;
}
.desc {
  margin-bottom: 20px;
}
.payment-result-page .hero-section .title.error-title {
  color: #dc3545;
}
.payment-result-page .hero-section .title.success {
  color: #0cbe19;
}
</style>
